<template>
	
<div class="chances">

	<div class="chances-title"><span>{{ section.treatment.more.chances.title }}</span><com-info :info="15" class="chances-info" /></div>

	<div class="chances-item" v-for="item in items" :key="item">

		<div class="chances-item-text">{{ section.treatment.more.chances[item]}}</div>

		<div class="chances-item-tick" :class="{'is-active': section.treatment[treatment][item] >= 5}"></div>
		<div class="chances-item-tick" :class="{'is-active': section.treatment[treatment][item] >= 4}"></div>
		<div class="chances-item-tick" :class="{'is-active': section.treatment[treatment][item] >= 3}"></div>
		<div class="chances-item-tick" :class="{'is-active': section.treatment[treatment][item] >= 2}"></div>
		<div class="chances-item-tick" :class="{'is-active': section.treatment[treatment][item] >= 1}"></div>

	</div>

</div>

</template>

<script>

import comInfo from '@/components/tool/common/section/form/Info'

export default {

	props: ['section', 'treatment'],

	components: {
		'com-info': comInfo
	},

	data: function() {

		return {
			items: ['spine', 'hip', 'other']
		}

	}

}

</script>

<style scoped>

.chances {
	background-color: #fff;
	padding: 32px;
	border-radius: 17px;
	margin-bottom: 16px;
	min-height: 264px;
	background-image: url(~@/assets/aid/risk/skeleton.svg);
	background-repeat: no-repeat;
	background-size: auto 200px;
	background-position: calc(100% - 32px) 32px;
}

.chances-title {
	color: #343434;
	font-size: 24px;
	margin-bottom: 32px;
	font-weight: 600;
	display: flex;
	align-items: center;
	gap: 10px;
}

.chances-title .chances-info {
	position: relative;
	right: auto;
	top: auto;
}

.chances-item {
	display: flex;
	margin-bottom: 10px;
}

.chances-item:last-child {
	margin-bottom: 0px;
}

.chances-item-text {
	color: #343434;
	font-size: 18px;
	line-height: 26px;
	width: 300px;
}

.chances-item-tick {
	width: 26px;
	margin: 0px 5px;
	height: 26px;
	border-radius: 130px;
	background-color: #F6F6F6;
}

.chances-item-tick.is-active {
	background-color: #F8A533;
	background-image: url(~@/assets/aid/common/icon.tick.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

</style>